import React, { useState,useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { login, getEmployeeByToken } from '../../api/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthProvider';
import { FcGoogle } from 'react-icons/fc';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';
import Cookie from 'js-cookie'
import { IoMdClose } from 'react-icons/io';
import img from '../../assets/660.png';

const Login = () => {
  const { user,isLogin,setUser, setLogin } = useAuth();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    try {
      const res = await login(formData);
      console.log(res);
      // localStorage.setItem('user', JSON.stringify(res.data));
      if (res.data?.isFirstLogin) {
        navigate('/signup');  // Navigate to signup if it's the first login
      } else {
        navigate(from, { replace: true });  // Go back to the page user was trying to access
      }
      // Cookie.set('token',res.data?.token)
      // Fetch full user data using token to ensure consistent data structure
      const userData = await getEmployeeByToken();
      setUser(userData.data);
      setLogin(true);
      setFormData({
        email: '',
        password: ''
      });
      toast.success(res.message);
    } catch (err) {
      console.log('ERRR',err)
      toast.error(err .response?.data?.message);
    }
  };

  useEffect(() => {
    if (isLogin) {
      navigate(from, { replace: true });
    }
  }, [isLogin, navigate, from]);

  return (
    <div className="flex flex-col  h-screen    relative   lg:flex-row max-w-6xl items-center  mx-auto justify-center  p-4">
      {/* Image - visible on desktop, hidden on mobile */}
      <div className="  hidden lg:block w-1/2 p-8 rounded-l-2xl">
        {/* <div className="absolute top-[-11px] right-[-10px] p-2 bg-white border shadow-sm rounded-full hover:text-red-600">
          <IoMdClose />
        </div> */}
        <img src={img} alt="Shoes" className="top-24" />
      </div>

      {/* Form - takes full width on mobile, half width on desktop */}
      <div className="p-8 rounded-lg w-full lg:w-1/2">
        <h2 className="text-3xl font-bold text-center mb-6">WELCOME BACK!</h2>
        <p className="text-center text-gray-600 mb-8">Please enter your details</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-3 border-gray-400 border-b-2 focus:outline-none focus:border-black"
              required
            />
          </div>
          <div className="mb-4 flex relative">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-3 border-gray-400 border-b-2 focus:outline-none focus:border-black"
            />
            {showPassword ? (
              <RiEyeLine onClick={togglePasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            ) : (
              <RiEyeCloseLine onClick={togglePasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            )}
          </div>

          <div className="flex space-x-2 justify-between">
            <span className="flex space-x-2 items-center">
              <label className="flex cursor-pointer select-none items-center">
                <div className="relative">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                  />
                  <div className="block h-6 w-12 rounded-full bg-gray-300 peer-checked:bg-black transition-colors duration-300"></div>
                  <div className="dot absolute left-1 top-1 h-4 w-4 rounded-full bg-white transition-transform duration-300 transform peer-checked:translate-x-6"></div>
                </div>
              </label>
              <p className="text-xs">Remember me</p>
            </span>
            <Link to="/signup"> 
            <p className="text-xs hover:underline">Forgot password?</p>
            </Link>
          </div>

          <button type="submit" className="w-full mt-4 bg-black text-white p-3 rounded-3xl hover:bg-gray-800 transition">
            Login
          </button>

         
        </form>

         
      </div>
    </div>
  );
};

export default Login;
